import { render } from "./Billing.vue?vue&type=template&id=2fac0bf4&scoped=true&ts=true"
import script from "./Billing.vue?vue&type=script&lang=ts"
export * from "./Billing.vue?vue&type=script&lang=ts"

import "./Billing.vue?vue&type=style&index=0&id=2fac0bf4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fac0bf4"]])

export default __exports__